<div class="devices-wrapper">
  <div class="device-nav">
    <div class="device-nav-text">
      <h3 i18n="@@successHeading">{{ planName }}</h3>
      <p i18n="@@paragraph">Devices attached to your plan</p>
    </div>
  </div>

  <div class="devices-outer d-flex flex-column justify-content-between">
    <div class="devices-card-wrapper">
      <div class="device-card" *ngFor="let device of successDeviceList">
        <span class="device image-outer">
          <img
            class="device-image"
            [src]="
              getImageUrl(
                device?.device_model_id
                  ? device?.device_model_id
                  : device?.model
              )
            "
            alt=" "
          />
        </span>
        <div class="card-text">
          <p>{{ device?.device_model_id }}</p>
          <span>{{ device?.id }}</span>
        </div>

        <div>
          <span class="check-icon-span">
            <img src="assets/images/successmark.svg" alt=" " />
          </span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!successDeviceList?.length">
      <app-no-records-found></app-no-records-found>
    </ng-container>
  </div>
  <div class="footer">
    <button class="btn" (click)="modifyPlan(true)">
      <span i18n="@@modifySuccess">Modify Plan</span>
    </button>
  </div>
</div>
